// tslint:disable-next-line: no-string-litera
import { Injectable } from '@angular/core';

@Injectable()
export class LandingService {
  public LANDING_FILTERS_CATEGORIES = {
    alojamientos: 'ACCOMMODATION_TYPE',
    estrellas: 'STAR',
    servicios: 'AMENITY',
  };

  constructor() {}

  private normalizeFilter(urlSegments: any[]) {
    const filterCategory = urlSegments.filter((segment: string) => {
      return (
        segment.includes('alojamientos') ||
        segment.includes('servicios') ||
        segment.includes('estrellas')
      );
    })[0];

    return filterCategory;
  }

  private getFilterCode(slug: string, segment: any, filtersList: any[]) {
    const category = filtersList.filter((filter) => {
      return filter.type === this.LANDING_FILTERS_CATEGORIES[segment];
    })[0];
    const value = category.values.filter((fil: any) => {
      const normalizedFilter = fil.description.split(' ').join('-').toLowerCase();
      const normalizedSlug = slug.split(' ').join('-').toLowerCase();
      const inclu = normalizedSlug.includes(`${normalizedFilter}-`);
      return inclu;
    })[0];
    return value && value.code;
  }

  public getFilterCategory(action: any) {
    const urlSegment = this.normalizeFilter(action.query.url.split('/'));
    const filterCode = urlSegment.includes('estrellas')
      ? urlSegment.split('-')[0]
      : this.getFilterCode(action.query.name, urlSegment, action.filters.list);
    if (urlSegment.includes('estrellas')) {
      return {
        [this.LANDING_FILTERS_CATEGORIES['estrellas']]: Number(filterCode),
      };
    }
    return {
      [this.LANDING_FILTERS_CATEGORIES[urlSegment]]: Number(filterCode),
    };
  }
}
